export default __webpack_public_path__ + "static/media/DRF.df4365aa.png";